import { useTranslation } from 'react-i18next';

import {
  Icon,
  Button,
  ICONS,
  Typography,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { ActionFooterContainer, FooterButtonContainer } from './action-footer.styles';

import { IEmployeeQuestionnaireSettingsFormFooterProps } from '../../../../employee-questionnaire-settings-interfaces';

const ActionFooter = ({
  count,
  countAll,
  handleMove,
  handleMoveAll,
  buttonPosition,
}: IEmployeeQuestionnaireSettingsFormFooterProps) => {
  const { t } = useTranslation();

  return (
    <ActionFooterContainer>
      <Typography>{t('settings:employeeQuestionnaire.labels.selectedItems', { count })}</Typography>
      <FooterButtonContainer>
        <Button onClick={handleMove}>
          {buttonPosition === 'right' && (
            <Icon
              rightMargin={false}
              icon={ICONS.chevronLeft}
              size={16}
              color={PLATFORM_THEME_COLORS.primary.blue}
            />
          )}
          {t('settings:employeeQuestionnaire.buttons.moveTo')}
          {buttonPosition === 'left' && (
            <Icon
              rightMargin={false}
              icon={ICONS.chevronRight}
              size={16}
              color={PLATFORM_THEME_COLORS.primary.blue}
            />
          )}
        </Button>
        <div className={'line'} />
        <Button onClick={handleMoveAll}>
          {t('settings:employeeQuestionnaire.buttons.moveAll', { count: countAll })}
        </Button>
      </FooterButtonContainer>
    </ActionFooterContainer>
  );
};

export default ActionFooter;
